(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@shraddhar/web/overlay'), require('@angular/cdk/portal'), require('@angular/cdk/a11y'), require('@shraddhar/web/base'), require('rxjs'), require('@material/snackbar'), require('rxjs/operators')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/snackbar', ['exports', '@angular/core', '@angular/common', '@shraddhar/web/overlay', '@angular/cdk/portal', '@angular/cdk/a11y', '@shraddhar/web/base', 'rxjs', '@material/snackbar', 'rxjs/operators'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.snackbar = {}), global.ng.core, global.ng.common, global.ng.web.overlay, global.ng.cdk.portal, global.ng.cdk.a11y, global.ng.web.base, global.rxjs, global.mdc.snackbar, global.rxjs.operators));
}(this, (function (exports, i0, common, i1, portal, a11y, base, rxjs, snackbar, operators) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    /**
     * Reference to a snackbar dispatched from the snackbar service.
     */
    var MdcSnackbarRef = /** @class */ (function () {
        function MdcSnackbarRef(containerInstance, _overlayRef) {
            this.containerInstance = containerInstance;
            this._overlayRef = _overlayRef;
            /** Subject for notifying the user that the snackbar has been dismissed. */
            this._afterDismiss = new rxjs.Subject();
            this.componentInstance = containerInstance;
        }
        /** Gets an observable that is notified when the snackbar is finished closing. */
        MdcSnackbarRef.prototype.afterDismiss = function () {
            return this._afterDismiss.asObservable();
        };
        MdcSnackbarRef.prototype.dismiss = function (reason) {
            if (!this._afterDismiss.closed) {
                this._dismissedReason = reason;
                this._finishDismiss();
            }
        };
        /** Cleans up the DOM after closing. */
        MdcSnackbarRef.prototype._finishDismiss = function () {
            this._overlayRef.dispose();
            this._afterDismiss.next(this._dismissedReason);
            this._afterDismiss.complete();
        };
        return MdcSnackbarRef;
    }());

    /** Injection token that can be used to access the data that was passed in to a snackbar. */
    var MDC_SNACKBAR_DATA = new i0.InjectionToken('MdcSnackbarData');
    var MdcSnackbarConfig = /** @class */ (function () {
        function MdcSnackbarConfig() {
            /** Data being injected into the child component. */
            this.data = null;
            /** Positions the action button/icon below the label instead of alongside it. */
            this.stacked = false;
            /** Positions the snackbar on the leading edge of the screen */
            this.leading = false;
            /** Positions the snackbar on the trailing edge of the screen */
            this.trailing = false;
            /** The layout direction of the snackbar content */
            this.direction = 'ltr';
            /** Show dismiss ("X") icon */
            this.dismiss = false;
            /** Whether the snackbar closes when it is focused and the user presses the ESC key */
            this.closeOnEscape = true;
            /** The politeness level for the screen reader announcement. */
            this.politeness = 'polite';
        }
        return MdcSnackbarConfig;
    }());

    var MdcSnackbarComponent = /** @class */ (function (_super) {
        __extends(MdcSnackbarComponent, _super);
        function MdcSnackbarComponent(_changeDetectorRef, _liveAnnouncer, elementRef, snackbarRef, data) {
            var _this = _super.call(this, elementRef) || this;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._liveAnnouncer = _liveAnnouncer;
            _this.elementRef = elementRef;
            _this.snackbarRef = snackbarRef;
            _this.data = data;
            _this._root = _this.elementRef.nativeElement;
            return _this;
        }
        Object.defineProperty(MdcSnackbarComponent.prototype, "config", {
            get: function () {
                return this.snackbarRef.componentInstance.snackbarConfig;
            },
            enumerable: true,
            configurable: true
        });
        MdcSnackbarComponent.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                announce: function () { return _this.label.nativeElement ? _this._liveAnnouncer.announce(_this.config.data.message, _this.config.politeness, _this.config.timeoutMs || snackbar.MDCSnackbarFoundation.numbers.ARIA_LIVE_DELAY_MS) : {}; },
                notifyClosed: function (reason) { return _this.snackbarRef.dismiss(reason); }
            };
            return new snackbar.MDCSnackbarFoundation(adapter);
        };
        MdcSnackbarComponent.prototype.ngOnInit = function () {
            this._changeDetectorRef.detectChanges();
            this._applyClasses();
            this._applyConfig();
        };
        MdcSnackbarComponent.prototype.ngOnDestroy = function () {
            if (this._foundation) {
                this._foundation.destroy();
            }
        };
        MdcSnackbarComponent.prototype._onKeydown = function (evt) {
            this._foundation.handleKeyDown(evt);
        };
        MdcSnackbarComponent.prototype._onActionClick = function (evt) {
            this._foundation.handleActionButtonClick(evt);
        };
        MdcSnackbarComponent.prototype._onActionIconClick = function (evt) {
            this._foundation.handleActionIconClick(evt);
        };
        MdcSnackbarComponent.prototype.open = function () {
            this._foundation.open();
        };
        MdcSnackbarComponent.prototype.close = function (reason) {
            this._foundation.close(reason !== undefined ? reason.action ? 'action' : reason.dismiss ? 'dismiss' : '' : '');
        };
        MdcSnackbarComponent.prototype._applyClasses = function () {
            var _a, _b, _c;
            var classes = this.config.classes;
            if (classes) {
                if (classes instanceof Array) {
                    (_a = this._elementRef.nativeElement.classList).add.apply(_a, __spread(this.config.classes));
                }
                else {
                    this._root.classList.toggle(classes);
                }
            }
            var actionClasses = this.config.actionClasses;
            if (actionClasses && this.action) {
                if (actionClasses instanceof Array) {
                    (_b = this.action.nativeElement.classList).add.apply(_b, __spread(this.config.actionClasses));
                }
                else {
                    this.action.nativeElement.classList.toggle(actionClasses);
                }
            }
            if (this.dismiss) {
                var dismissClasses = this.config.dismissClasses;
                if (dismissClasses) {
                    if (dismissClasses instanceof Array) {
                        (_c = this.dismiss.nativeElement.classList).add.apply(_c, __spread(this.config.dismissClasses));
                    }
                    else {
                        this.dismiss.nativeElement.classList.toggle(dismissClasses);
                    }
                }
            }
        };
        MdcSnackbarComponent.prototype._applyConfig = function () {
            if (this.config.timeoutMs) {
                this._foundation.setTimeoutMs(this.config.timeoutMs);
            }
            if (this.config.dismiss) {
                this._foundation.setCloseOnEscape(this.config.closeOnEscape ? true : false);
            }
        };
        MdcSnackbarComponent.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-snackbar',
                        host: {
                            'class': 'mdc-snackbar',
                            '[dir]': 'config.direction',
                            '[class.mdc-snackbar--stacked]': 'config.stacked',
                            '[class.mdc-snackbar--leading]': 'config.leading',
                            '[class.ngx-mdc-snackbar--trailing]': 'config.trailing',
                            '(keydown)': '_onKeydown($event)'
                        },
                        template: "<div #surface class=\"mdc-snackbar__surface\">\r\n  <div #label class=\"mdc-snackbar__label\"\r\n    role=\"status\"\r\n    aria-live=\"polite\">{{data.message}}</div>\r\n  <div class=\"mdc-snackbar__actions\">\r\n    <button #action type=\"button\" class=\"mdc-button mdc-snackbar__action\"\r\n      (click)=\"_onActionClick($event)\">{{data.action}}</button>\r\n    <button #dismiss *ngIf=\"config.dismiss\"\r\n      class=\"mdc-icon-button mdc-snackbar__dismiss material-icons\"\r\n      title=\"Dismiss\" (click)=\"_onActionIconClick($event)\">close</button>\r\n  </div>\r\n</div>",
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None,
                        providers: [a11y.LiveAnnouncer]
                    }] }
        ];
        /** @nocollapse */
        MdcSnackbarComponent.ctorParameters = function () { return [
            { type: i0.ChangeDetectorRef },
            { type: a11y.LiveAnnouncer },
            { type: i0.ElementRef },
            { type: MdcSnackbarRef },
            { type: undefined, decorators: [{ type: i0.Inject, args: [MDC_SNACKBAR_DATA,] }] }
        ]; };
        MdcSnackbarComponent.propDecorators = {
            label: [{ type: i0.ViewChild, args: ['label', { static: true },] }],
            action: [{ type: i0.ViewChild, args: ['action', { static: false },] }],
            dismiss: [{ type: i0.ViewChild, args: ['dismiss', { static: false },] }]
        };
        return MdcSnackbarComponent;
    }(base.MDCComponent));

    var MdcSnackbarContainer = /** @class */ (function (_super) {
        __extends(MdcSnackbarContainer, _super);
        function MdcSnackbarContainer(_ngZone, snackbarConfig) {
            var _this = _super.call(this) || this;
            _this._ngZone = _ngZone;
            _this.snackbarConfig = snackbarConfig;
            /** Subject for notifying that the snackbar has exited from view. */
            _this._onExit = new rxjs.Subject();
            return _this;
        }
        /** Attach a component portal as content to this snackbar container. */
        MdcSnackbarContainer.prototype.attachComponentPortal = function (portal) {
            return this._portalOutlet.attachComponentPortal(portal);
        };
        /** Attach a template portal as content to this snackbar container. */
        MdcSnackbarContainer.prototype.attachTemplatePortal = function (portal) {
            return this._portalOutlet.attachTemplatePortal(portal);
        };
        MdcSnackbarContainer.prototype.ngOnDestroy = function () {
            this._completeExit();
        };
        /**
         * Waits for the zone to settle before removing the element. Helps prevent
         * errors where we end up removing an element which is in the middle of an animation.
         */
        MdcSnackbarContainer.prototype._completeExit = function () {
            var _this = this;
            this._ngZone.onMicrotaskEmpty.asObservable().pipe(operators.take(1)).subscribe(function () {
                _this._onExit.next();
                _this._onExit.complete();
            });
        };
        MdcSnackbarContainer.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-snackbar-container',
                        template: '<ng-template cdkPortalOutlet></ng-template>',
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcSnackbarContainer.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: MdcSnackbarConfig }
        ]; };
        MdcSnackbarContainer.propDecorators = {
            _portalOutlet: [{ type: i0.ViewChild, args: [portal.CdkPortalOutlet, { static: true },] }]
        };
        return MdcSnackbarContainer;
    }(portal.BasePortalOutlet));

    var MdcSnackbarModule = /** @class */ (function () {
        function MdcSnackbarModule() {
        }
        MdcSnackbarModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            i1.OverlayModule,
                            portal.PortalModule,
                        ],
                        exports: [MdcSnackbarContainer],
                        declarations: [MdcSnackbarContainer, MdcSnackbarComponent],
                        entryComponents: [MdcSnackbarContainer, MdcSnackbarComponent]
                    },] }
        ];
        return MdcSnackbarModule;
    }());

    /** Injection token that can be used to specify default snackbar. */
    var MDC_SNACKBAR_DEFAULT_OPTIONS = new i0.InjectionToken('mdc-snackbar-default-options', {
        providedIn: 'root',
        factory: MDC_SNACKBAR_DEFAULT_OPTIONS_FACTORY,
    });
    /** @docs-private */
    function MDC_SNACKBAR_DEFAULT_OPTIONS_FACTORY() {
        return new MdcSnackbarConfig();
    }
    var MdcSnackbar = /** @class */ (function () {
        function MdcSnackbar(_overlay, _injector, _parentSnackbar, _defaultConfig) {
            this._overlay = _overlay;
            this._injector = _injector;
            this._parentSnackbar = _parentSnackbar;
            this._defaultConfig = _defaultConfig;
            /**
             * Reference to the current snackbar in the view *at this level* (in the Angular injector tree).
             * If there is a parent snack-bar service, all operations should delegate to that parent
             * via `_openedSnackbarRef`.
             */
            this._snackbarRefAtThisLevel = null;
        }
        Object.defineProperty(MdcSnackbar.prototype, "_openedSnackbarRef", {
            /** Reference to the currently opened snackbar at *any* level. */
            get: function () {
                var parent = this._parentSnackbar;
                return parent ? parent._openedSnackbarRef : this._snackbarRefAtThisLevel;
            },
            set: function (value) {
                if (this._parentSnackbar) {
                    this._parentSnackbar._openedSnackbarRef = value;
                }
                else {
                    this._snackbarRefAtThisLevel = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Creates and dispatches a snackbar with a custom component for the content, removing any
         * currently opened snackbars.
         *
         * @param component Component to be instantiated.
         * @param config Extra configuration for the snackbar.
         */
        MdcSnackbar.prototype.openFromComponent = function (component, config) {
            return this._attach(component, config);
        };
        /**
         * Opens a snackbar with a message and an optional action.
         * @param message Message text.
         * @param action Optional label for the snackbar action.
         * @param config Optional additional configuration options for the snackbar.
         */
        MdcSnackbar.prototype.open = function (message, action, config) {
            var _config = __assign(__assign({}, this._defaultConfig), config);
            // Since the user doesn't have access to the component, we can
            // override the data to pass in our own message and action.
            _config.data = { message: message, action: action };
            return this.openFromComponent(MdcSnackbarComponent, _config);
        };
        /**
         * Dismisses the currently-visible snackbar.
         */
        MdcSnackbar.prototype.dismiss = function () {
            if (this._openedSnackbarRef) {
                if (this._openedSnackbarRef.instance instanceof MdcSnackbarComponent) {
                    this._openedSnackbarRef.instance.close();
                }
                this._openedSnackbarRef.dismiss();
            }
        };
        MdcSnackbar.prototype.ngOnDestroy = function () {
            var _a;
            // Only dismiss the snackbar at the current level on destroy.
            (_a = this._snackbarRefAtThisLevel) === null || _a === void 0 ? void 0 : _a.dismiss();
        };
        /**
         * Attaches the snackbar container component to the overlay.
         */
        MdcSnackbar.prototype._attachSnackbarContainer = function (overlayRef, config) {
            var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            var injector = new portal.PortalInjector(userInjector || this._injector, new WeakMap([
                [MdcSnackbarConfig, config]
            ]));
            var containerPortal = new portal.ComponentPortal(MdcSnackbarContainer, config.viewContainerRef, injector);
            var containerRef = overlayRef.attach(containerPortal);
            containerRef.instance.snackbarConfig = config;
            return containerRef.instance;
        };
        /**
         * Places a new component or a template as the content of the snackbar container.
         */
        MdcSnackbar.prototype._attach = function (content, userConfig) {
            var config = __assign(__assign(__assign({}, new MdcSnackbarConfig()), this._defaultConfig), userConfig);
            var overlayRef = this._createOverlay();
            var container = this._attachSnackbarContainer(overlayRef, config);
            var snackbarRef = new MdcSnackbarRef(container, overlayRef);
            var injector = this._createInjector(config, snackbarRef);
            var portal$1 = new portal.ComponentPortal(content, undefined, injector);
            var contentRef = container.attachComponentPortal(portal$1);
            // We can't pass this via the injector, because the injector is created earlier.
            snackbarRef.instance = contentRef.instance;
            this._loadListeners(snackbarRef);
            this._openedSnackbarRef = snackbarRef;
            if (snackbarRef.instance instanceof MdcSnackbarComponent) {
                snackbarRef.instance.open();
            }
            return this._openedSnackbarRef;
        };
        MdcSnackbar.prototype._loadListeners = function (snackbarRef) {
            var _this = this;
            var _a;
            // When the snackbar is dismissed, clear the reference to it.
            snackbarRef.afterDismiss().subscribe(function () {
                // Clear the snackbar ref if it hasn't already been replaced by a newer snackbar.
                if (_this._openedSnackbarRef === snackbarRef) {
                    _this._openedSnackbarRef = null;
                }
            });
            (_a = this._openedSnackbarRef) === null || _a === void 0 ? void 0 : _a.dismiss();
        };
        /**
         * Creates a new overlay and places it in the correct location.
         * @param config The user-specified snackbar config.
         */
        MdcSnackbar.prototype._createOverlay = function () {
            return this._overlay.create();
        };
        /**
         * Creates an injector to be used inside of a snackbar component.
         * @param config Config that was used to create the snackbar.
         * @param snackbarRef Reference to the snackbar.
         */
        MdcSnackbar.prototype._createInjector = function (config, snackbarRef) {
            var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            return new portal.PortalInjector(userInjector || this._injector, new WeakMap([
                [MdcSnackbarRef, snackbarRef],
                [MDC_SNACKBAR_DATA, config.data]
            ]));
        };
        MdcSnackbar.decorators = [
            { type: i0.Injectable, args: [{ providedIn: MdcSnackbarModule },] }
        ];
        /** @nocollapse */
        MdcSnackbar.ctorParameters = function () { return [
            { type: i1.Overlay },
            { type: i0.Injector },
            { type: MdcSnackbar, decorators: [{ type: i0.Optional }, { type: i0.SkipSelf }] },
            { type: MdcSnackbarConfig, decorators: [{ type: i0.Inject, args: [MDC_SNACKBAR_DEFAULT_OPTIONS,] }] }
        ]; };
        MdcSnackbar.ɵprov = i0.ɵɵdefineInjectable({ factory: function MdcSnackbar_Factory() { return new MdcSnackbar(i0.ɵɵinject(i1.Overlay), i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(MdcSnackbar, 12), i0.ɵɵinject(MDC_SNACKBAR_DEFAULT_OPTIONS)); }, token: MdcSnackbar, providedIn: MdcSnackbarModule });
        return MdcSnackbar;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_SNACKBAR_DATA = MDC_SNACKBAR_DATA;
    exports.MDC_SNACKBAR_DEFAULT_OPTIONS = MDC_SNACKBAR_DEFAULT_OPTIONS;
    exports.MDC_SNACKBAR_DEFAULT_OPTIONS_FACTORY = MDC_SNACKBAR_DEFAULT_OPTIONS_FACTORY;
    exports.MdcSnackbar = MdcSnackbar;
    exports.MdcSnackbarComponent = MdcSnackbarComponent;
    exports.MdcSnackbarConfig = MdcSnackbarConfig;
    exports.MdcSnackbarContainer = MdcSnackbarContainer;
    exports.MdcSnackbarModule = MdcSnackbarModule;
    exports.MdcSnackbarRef = MdcSnackbarRef;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-snackbar.umd.js.map
